import { DEFAULT_COUNTRY_CODE } from '@constants/constants';
import type * as Types from './cartApiTypes';

export function transformGetCartResponse(data: Types.IGetCartAPIResponse): Types.IGetCartResponse {
  const costs = { ...(data?.costs ?? undefined) };

  if (data?.shipmentMethodCode !== '') {
    costs.shipment = {
      exTax: { numeric: 0, formatted: '€ 0,00' },
      incTax: { numeric: 0, formatted: '€ 0,00' }
    };
  } else if (!costs.shipment) {
    // Remove grandTotal if shipment does not exist
    delete costs?.grandTotal;
  }

  return {
    ...data,
    registrationNr: data.customer?.registrationNr ?? '',
    vatRegistrationNr: data.customer?.vatRegistrationNr ?? '',
    companyName: data.address?.name ?? '',
    countryCode: data.address?.countryCode ?? DEFAULT_COUNTRY_CODE,
    postalCode: data.address?.postalCode ?? '',
    houseNumber: data.address?.houseNumber ?? '',
    houseNumberAddition: data.address?.houseNumberAddition ?? '',
    city: data.address?.city ?? '',
    street: data.address?.street ?? '',
    lines: data.lines.map((line) => ({
      ...line,
      variantCode: line.variant.code,
      variantTitle: line.variant.title,
      //@ts-expect-error: in the API response this field is still called 'customerReference'
      reference: line.customerReference ?? line.reference
    })),
    ...(data?.costs ? { costs } : {})
  };
}
